import { render, staticRenderFns } from "./UsersChat.vue?vue&type=template&id=0289f3ef&scoped=true&"
import script from "./UsersChat.vue?vue&type=script&lang=js&"
export * from "./UsersChat.vue?vue&type=script&lang=js&"
import style0 from "./UsersChat.vue?vue&type=style&index=0&id=0289f3ef&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0289f3ef",
  null
  
)

export default component.exports